export default __webpack_public_path__ + "static/media/tas-navbar.01e60679.svg";